import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4916efaf&lang=scss&scoped=true"

import exportComponent from "/root/workspace/theone-chain-explorer-frontend_KUia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4916efaf"]])

export default __exports__